import One from '../../images/one.jpg'
import Eleven from '../../images/eleven.jpg'
import Eight from '../../images/eight.jpg'
import Toile1 from '../../images/toile1.jpg'

export const CATEGORIES = [
    {
        id: 1,
        name:'Sac à main',
        slug:'sac-a-main',
        description:'Sac à main',
        image: One,
    },
    {
        id: 2,
        name:'Cartable',
        slug:'cartable',
        description:'Cartable',
        image: Eight,
    },
    {
        id: 3,
        name:'Toile',
        slug:'toile',
        description:'Toile',
        image: Toile1,
    },
    {
        id: 4,
        name:'Housse pour ordinateur',
        slug:'housse',
        description:'Housse pour ordinateur',
        image: Eleven,
    },
]